/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamImportExamItemBatch202,
  PostApiV1ExamImportExamItemBatch400,
  PostApiV1ExamImportExamItemBatch401,
  PostApiV1ExamImportExamItemBatch404,
  PostApiV1ExamImportExamItemBatch500,
  PostApiV1ExamImportExamItemBatchMutationRequest,
  PostApiV1ExamImportExamItemBatchMutationResponse,
} from "../../types/examEvaluationController/PostApiV1ExamImportExamItemBatch.ts";
import { importExamItemBatchViewModelSchema } from "../importExamItemBatchViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamImportExamItemBatch202Schema =
  z.any() as unknown as ToZod<PostApiV1ExamImportExamItemBatch202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamImportExamItemBatch400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamImportExamItemBatch400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamImportExamItemBatch401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamImportExamItemBatch401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ExamImportExamItemBatch404Schema =
  z.any() as unknown as ToZod<PostApiV1ExamImportExamItemBatch404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamImportExamItemBatch500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamImportExamItemBatch500>;

export const postApiV1ExamImportExamItemBatchMutationRequestSchema = z.lazy(
  () => importExamItemBatchViewModelSchema,
) as unknown as ToZod<PostApiV1ExamImportExamItemBatchMutationRequest>;

export const postApiV1ExamImportExamItemBatchMutationResponseSchema = z.lazy(
  () => postApiV1ExamImportExamItemBatch202Schema,
) as unknown as ToZod<PostApiV1ExamImportExamItemBatchMutationResponse>;
